import React from 'react';
import map from 'lodash/map';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import PageSection from '../components/PageSection';
import { mapping as iconMapping } from '../components/icons/Attributes';
import phrasesType from '../proptypes/phrases';
import rankingType, { additionalRankingType } from '../proptypes/ranking';
import getAttributeLink from '../selectors/get-attribute-link';

const renderIcon = (key) => {
  if (iconMapping[key]) {
    const Icon = iconMapping[key];
    return (
      <span className="explore-your-attribute__attribute_icon">
        <Icon />
      </span>
    );
  }
  return <span className="explore-your-attribute__icon">?</span>;
};

const selectAttributes = (ranking, additionalRanking) => {
  if (Object.values(additionalRanking).some(v => v > 0)) {
    return [...Object.keys(ranking), ...Object.keys(additionalRanking)];
  }
  return Object.keys(ranking);
};

const ExploreYourAttributesSection = ({
  ranking, additionalRanking, phrases, attributePath,
}) => {
  const attributes = selectAttributes(ranking, additionalRanking);

  return (
    <PageSection theme="dark_navy">
      <div className="explore-your-attributes">
        <div className="row">
          <div className="col-12">
            <h3 className="explore-your-attributes__heading">{phrases.exploreYourAttributesTitle}</h3>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <ul className="explore-your-attributes__attributes">
              {map(attributes, key => (
                <li key={key} className={clsx('explore-your-attributes__attribute', `explore-your-attributes__attribute--${key}`)}>
                  <a href={getAttributeLink(attributePath, key)}>
                    {renderIcon(key)}
                    <span className="explore-your-attributes__attribute_name">
                      {phrases[`${key}Title`]}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </PageSection>
  );
};

ExploreYourAttributesSection.defaultProps = {
  ranking: {},
  additionalRanking: {},
};

ExploreYourAttributesSection.propTypes = {
  ranking: rankingType,
  additionalRanking: additionalRankingType,
  phrases: phrasesType.isRequired,
  attributePath: PropTypes.string.isRequired,
};

export default ExploreYourAttributesSection;
